import React from 'react'
import { Link } from 'react-router-dom';

export default function Footer() {

  return (
    <footer className='footer padding-left-right' style={{ paddingTop: '50px' }}>

      <div className='container'>
        <div className='row'>
          <div className='col-lg-3 col-md-6 mt-3'>
            <div className='footer-logo'>
              <img src={require("../assets/images/logo.png")} alt='' />
            </div>
          </div>
          <div className='col-lg-3 col-md-6'>
            <div className='footer-txt'>
              <p className='para_text1 d-flex'><i className="fa fa-envelope mt-2" aria-hidden="true"></i>&nbsp;sales@cloudmindme.com</p>
            </div>
          </div>
          <div className='col-lg-3 col-md-6'>
            <div className='footer-txt'>
              <p className='para_text1'><i className="fa fa-phone" aria-hidden="true"></i> +971 501227432</p>
            </div>
          </div>
          <div className='col-lg-3 col-md-6'>
            <div className='footer-col'>
              <div className="social-links">
                <li>
                  <a href="https://www.facebook.com" target='_blank' rel="noreferrer"><i className="fa-brands fa-facebook-f"></i></a>
                </li>
                <li>
                  <a href="https://www.instagram.com" target='_blank' rel="noreferrer"><i className="fa-brands fa-instagram"></i></a>
                </li>
                <li>
                  <a href="https://www.linkedin.com/company/cloud-mind" target='_blank' rel="noreferrer"><i className="fa-brands fa-linkedin-in"></i></a>
                </li>
                <li>
                  <a href="https://www.twitter.com" target='_blank' rel="noreferrer"><i className="fa-brands fa-twitter"></i></a>
                </li>
              </div>
            </div>
          </div>
        </div>
        <div className='divider'></div>
      </div>

      <div className='container mt-4'>
        <div className='row'>
          <div className='col-lg-3 col-md-6'>
            <div className='footer-item'>
              <h3 className='pl-2'>Products</h3>
              <div className='link-item pl-2'>
                <p><Link to="/enterprise-mobility-security">EnterPrise Mobility & Security</Link></p>
                <p><Link to="/enterprise-network-ndr">EnterPrise Network & NDR</Link></p>
                <p><Link to="/digital-workspace">Digital Workspace</Link></p>
                <p><Link to="/data-management">Data Management</Link></p>
                <p><Link to="/ransomware">Ransomware</Link></p>
              </div>
            </div>
          </div>
          <div className='col-lg-3 col-md-6'>
            <div className='footer-item'>
              <h3 className='pl-2'>Technology</h3>
              <div className='link-item pl-2'>
                <p><Link to="/zero-trust">Zero Trust</Link></p>
                <p><Link to="/soar">SOAR</Link></p>
                <p><Link to="/artificial-intelligence">Artificial Intelligence</Link></p>
                <p><Link to="/machine-learning">Machine Learning</Link></p>
                <p><Link to="/deception-technology">Deception Technology</Link></p>
              </div>
            </div>
          </div>
          <div className='col-lg-3 col-md-6'>
            <div className='footer-item'>
              <h3 className='pl-2'>Useful Links</h3>
              <div className='link-item pl-2'>
                <p><Link to="/about">About Us</Link></p>
                <p><Link to="/contact">Contact Us</Link></p>
                <p><Link to="/career">Career</Link></p>
                <p><Link to="/partners">Partners</Link></p>
                <p><Link to="/leadership">Leadership</Link></p>
              </div>
            </div>
          </div>
          <div className='col-lg-3 col-md-6'>
            <div className='footer-item'>
              <h3 className='pl-2'>Resources</h3>
              <div className='link-item pl-2'>
                <p><Link to="/">Case Studies</Link></p>
                <p><Link to="/">Data Sheets</Link></p>
                <p><Link to="/">White Papers</Link></p>
                <p><Link to="/">Videos</Link></p>
                <p><Link to="/">Upcoming Events</Link></p>
              </div>
            </div>
          </div>
        </div>
        <div className='divider'></div>
        <p className='para_text1 text-center mt-4'>Copyright  &copy; 2026 CLOUD MIND</p>
      </div>

      <div className='container-'>
        <div className=' row'>
          <div className='col-lg-12'>
            <div className='copy-right-p text-center'>
            </div>
          </div>
        </div>
      </div>

    </footer>
  )
}


